import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AppSidebarLayout } from './components/layout/AppSidebar';
import { BreadcrumbNavigation } from './components/layout/BreadcrumbNavigation';
import { LiveDashboard } from './pages/Dashboard/LiveDashboard';
import { ExecuteWorkflow } from './pages/ExecuteWorkflow/ExecuteWorkflow';
import { ManageScripts } from './pages/ManageScripts/ManageScripts';
import { History } from './pages/History/History';
import { Tradesparq } from './pages/Tools/Tradesparq';
import { BOMManagement } from './pages/Tools/BOMManagement';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import { Toaster } from './components/ui/toaster';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <ErrorBoundary>
          <AppSidebarLayout>
            <BreadcrumbNavigation />
            <Routes>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<LiveDashboard />} />
              <Route path="/execute" element={<ExecuteWorkflow />} />
              <Route path="/scripts" element={<ManageScripts />} />
              <Route path="/history" element={<History />} />
              <Route path="/tools/tradesparq" element={<Tradesparq />} />
              <Route path="/tools/bom" element={<BOMManagement />} />
              {/* Add a catch-all route for 404 */}
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </AppSidebarLayout>
          <Toaster />
        </ErrorBoundary>
      </Router>
    </QueryClientProvider>
  );
}

export default App;